<template>
  <div id="messageText">
    <div class="messtitle"><div>純文字訊息</div> <span> (請輸入500字內)</span></div>
    <textarea v-model="textContent" ref="text"></textarea>
    <div class="emojis">
      <span v-for="(emoji, j) in emojis" :key="`emoji-${j}`" @click="addemoji(emoji)">{{emoji}}</span>
    </div>
  </div>
</template>

<script>
import { emoji as emojis } from '../../../store/map'
export default {
  props: ['defaultValue'],
  data () {
    return {
      emojis: emojis(),
      textContent: null
    }
  },
  watch: {
    defaultValue: {
      handler () {
        if (typeof this.defaultValue === 'string' || !this.defaultValue) {
          this.textContent = this.defaultValue
        }
      }
    },
    textContent () {
      if (this.textContent !== this.defaultValue) {
        this.$emit('input', this.textContent)
      }
    }
  },
  mounted () {
    if (typeof this.defaultValue === 'string') {
      this.textContent = this.defaultValue
    }
  },
  methods: {
    addemoji (Content) {
      try {
        this.$refs.text.focus()
        if (document.selection) {
          var mySelection = document.selection.createRange()
          mySelection.text = Content
          this.textContent = this.$refs.text.value
          console.log(Content)
        } else {
          const index = this.$refs.text.selectionStart
          var myPrefix = this.$refs.text.value.substring(0, this.$refs.text.selectionStart)
          var mySuffix = this.$refs.text.value.substring(this.$refs.text.selectionEnd)
          this.textContent = myPrefix + Content + mySuffix
          console.log('selectionStart', index)
          setTimeout(() => {
            this.$refs.text.setSelectionRange(index + 2, index + 2, 0)
          }, 50)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.emojis {
  margin-top: 26px;
  display: flex;
  flex-wrap: wrap;
  gap: 11px 14px;
  overflow-y: auto;
  max-height: 144px;
  span {
    display: inline-flex;
    width: 40px;
    height: 40px;
    font-size: 30px;
    align-items: center;
    justify-content: center;
  }
}
.messtitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  align-items: flex-end;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  height: 26px;
  gap: .5em;
  span {
    font-size: 12px;
    font-weight: 500;
    font-family: Roboto;
    line-height: 14px;
    color: #C4C4C4;
  }
}
textarea {
  height: 375px;
  border: 1px solid #C4C4C4;
  border-radius: 5px;
  color: #878787;
  width: 100%;
  margin-top: 11px;
  padding: 25px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.1em;
  color: #787878;
}
#messageText {
  width: 790px;
  height: 645px;
  border: 1px solid #CACACA;
  border-radius: 10px;
  padding: 25px 33px;
}
</style>
